module.exports = {
	imgPath:"https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/siyutuoke_img/",
	apiShareUrl:'https://auth.daominyoupin.com', //正式分享路径
	// apiShareUrl:'https://ttoker.7dingdong.com', //测试分享路径
	xyLinkUrl:window.location.href.split('#')[0],

}
